import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {MenuItem} from '../navigation/menu-items';
import {MenuBase} from '../menu-base/menu-base.component';
import {GoogleTagManagerService} from 'angular-google-tag-manager';
import {TrackingService} from '../../../../services/tracking.service';
import {AmplitudeService} from '../../../../services/amplitude.service';

@Component({
  selector: 'mc-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss'],
})
export class NavMenuComponent extends MenuBase implements OnInit {
  public menuItemsList: MenuItem[] = [];

  constructor(
    protected readonly router: Router,
    protected readonly gtmService: GoogleTagManagerService,
    protected readonly trackingService: TrackingService,
    protected readonly ampliService: AmplitudeService,
  ) {
    super(router, gtmService, trackingService, ampliService);
  }

  @Input() set menuItems(value: MenuItem[]) {
    this.menuItemsList = value;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  goToMenuItem(item: MenuItem) {
    this.router.navigate([item.routerLink]);
  }

  isActiveNavLink(menuItem: MenuItem): boolean {
    return (
      this.router.isActive(menuItem.routerLink, {
        paths: 'subset',
        queryParams: 'subset',
        fragment: 'ignored',
        matrixParams: 'ignored',
      }) || !!menuItem.menuItems?.find(({routerLink}) => this.currentRoute.startsWith(routerLink))
    );
  }
}
